export const iconFontAwesomeWeatherCloudSunRain = (
	<i className="fa-solid fa-cloud-sun-rain"></i>
);
